module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-9fc672e7.png";